// App.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Sidebar from "./components/Sidebar/Sidebar";
import Home from "./components/HomePage/HomePage";
// import Employee from "./components/Employee/Employee";
import Header from "./components/Header/Header";
import AddCountry from "./pages/Country/Country";
import CountryList from "./pages/Country/CountryList";
import EditCountry from "./pages/Country/EditCountry";
import RegionList from "./pages/Region/RegionList";
import RegionForm from "./pages/Region/RegionForm";
import AddDistrict from "./pages/District/District";
import DistrictList from "./pages/District/DistrictList";
import EditDistrict from "./pages/District/EditDistrict";
import AddJobCategory from "./pages/JobCategory/JobCategory";
import JobCategoryList from "./pages/JobCategory/JobCategoryList";
import EditJobCategory from "./pages/JobCategory/EditJobCategory";
import AddClient from "./pages/Client/Client";
import ClientList from "./pages/Client/ClientList";
import EditClient from "./pages/Client/EditClient";
import AddContract from "./pages/Contract/Contract";
import ContractList from "./pages/Contract/ContractList";
import ContractView from "./pages/Contract/ContractView";
import EditContract from "./pages/Contract/EditContract";
import AddTransfer from "./pages/Transfer/Transfer";
import TransferList from "./pages/Transfer/TransferList";
import TransferView from "./pages/Transfer/TransferView";
import EditTransfer from "./pages/Transfer/EditTransfer";
import IDCardGenerator from "./pages/IDCardGenerator/IDCardGenerator";
import MultiStepForm from "./pages/Registration/MultiStepForm";
import CustomerList from "./pages/Registration/CustomerList";
import CustomerDetails from "./pages/Registration/CustomerDetails";
import CustomerDocuments from "./pages/Registration/CustomerDocuments";
import CustomerJobs from "./pages/Registration/CustomerJobs";
import EditCustomerRegistration from "./pages/Registration/EditCustomer";
import DocumentsList from "./pages/Registration/DocumentsList";
import JobAvailabilityList from "./pages/Registration/JobAvailabilityList";
import RegistrationFeeList from "./pages/Registration/RegistrationFeeList";
import CustomerRegistrationFees from "./pages/Registration/CustomerRegistrationFees";
import EditRegistrationFee from "./pages/Registration/EditRegistrationFee";
import AddBank from "./pages/Bank/Bank";
import BankList from "./pages/Bank/BankList";
import EditBank from "./pages/Bank/EditBank";
import "./App.css";
import AddRole from "./pages/Role/Role";
import RoleList from "./pages/Role/RoleList";
import EditRole from "./pages/Role/EditRole";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute.jsx/ProtectedRoute";
import Unauthorized from "./pages/Unauthorized";
import Settings from "./pages/Settings/Settings";
// import UpdateUser from "./pages/users/UpdateUser";
import Register from "./pages/users/Register";
import Login from "./pages/users/Login";
// import EmployeeLists from "./pages/Settings/Employeelists";
import AddCompany from "./pages/Company/Company"
import CompanyList from "./pages/Company/CompanyList"
import EditCompany from "./pages/Company/EditCompany"
// import Payments from "./pages/Finance/Payments";
import ContractReport from "./pages/Reports/ContractReport";






// Loading spinner
function LoadingSpinner() {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading...</p>
    </div>
  );
}

// AppContent
function AppContent() {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  // haddii user aan login ahayn
  if (!currentUser) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // haddii user login yahay
  return (
    <div className="app-container">
      <Sidebar />
      <main className="main-content">
        <Header />
        <div className="content-wrapper">
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewRole"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <RoleList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddRole"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <AddRole />
                </ProtectedRoute>
              }
            />
            <Route
              path="/role/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <EditRole />
                </ProtectedRoute>
              }
            />




            <Route
              path="/AddDistrict"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddDistrict />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewDistrict"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <DistrictList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/district/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditDistrict />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddCountry"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddCountry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewCountry"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <CountryList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/country/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditCountry />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/AddJobCategory"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddJobCategory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewJobCategory"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <JobCategoryList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobcategory/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditJobCategory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddClient"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewClient"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <ClientList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/client/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddContract"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddContract />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewContract"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <ContractList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contract/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditContract />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contract/view/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <ContractView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddTransfer"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddTransfer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewTransfer"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <TransferList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transfer/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditTransfer />
                </ProtectedRoute>
              }
            />

            <Route
              path="/transfer/view/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <TransferView />
                </ProtectedRoute>
              }
            />
            <Route path="/IDCARD" element={<ProtectedRoute requiredRole={["admin", "HRM"]}><IDCardGenerator /></ProtectedRoute>} />
            <Route
              path="/IDCARD"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <IDCardGenerator />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/AddBank"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddBank />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewBank"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <BankList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bank/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditBank />
                </ProtectedRoute>
              }
            />
           

            <Route
              path="/AddCompany"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <AddCompany />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewCompany"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <CompanyList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/company/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <EditCompany />
                </ProtectedRoute>
              }
            />

            <Route
              path="/regions"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <RegionList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/regions/add"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <RegionForm />
                </ProtectedRoute>
              }
            />

            <Route
              path="/regions/edit/:id"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <RegionForm />
                </ProtectedRoute>
              }
            />
            <Route path="/register" element={<ProtectedRoute requiredRole={["admin", "developer"]}>  <Register />
            </ProtectedRoute>} />


            <Route path="/settings" element={<ProtectedRoute requiredRole={["developer"]}> <Settings />  </ProtectedRoute>} />


            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* Haddii user login yahay, hadduu isku dayo login/register → u dir home */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            {/* <Route path="/register" element={<Navigate to="/" replace />} /> */}

            <Route path="*" element={<Navigate to="/" replace />} />
            {/* Main registration form (3 steps) */}
            <Route
              path="/registration/new"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <MultiStepForm />
                </ProtectedRoute>
              }
            />

            {/* Customer management */}
            <Route
              path="/registration/customers"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <CustomerList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/registration/customer/:id"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <CustomerDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/registration/customer/edit/:id"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <EditCustomerRegistration />
                </ProtectedRoute>
              }
            />

            {/* Documents management */}
            <Route
              path="/registration/documents"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <DocumentsList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/registration/customer/:customerId/documents"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <CustomerDocuments />
                </ProtectedRoute>
              }
            />

            {/* Job Availability management */}
            <Route
              path="/registration/jobs"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <JobAvailabilityList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/registration/customer/:customerId/jobs"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <CustomerJobs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/registration/fees"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <RegistrationFeeList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/registration/fee/customer/:customerId"
              element={
                <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                  <CustomerRegistrationFees />
                </ProtectedRoute>
              }
            />
            <Route
              path="/registration/fee/edit/:id"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <EditRegistrationFee />
                </ProtectedRoute>
              }
            />

            <Route
            path="/contract/report/:id"
            element={
              <ProtectedRoute requiredRole={["developer", "admin"]}>
                <ContractReport />
              </ProtectedRoute>
            }
          />

          </Routes>
       
        </div>
      </main>
    </div>
  );
}

// App wrapper
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;